import { useState } from "react";
import { Button, Col, Container, Form, Row, Table } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { LeaderboardInstance } from "../utils/leaderboardClass";

export const AdminLeaderboardComponent = () => {
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [leaderboard, setLeaderboard] = useState([]);
  const [isUCA, setIsUCA] = useState(false);

  const fetchLeaderboard = async () => {
    if (!startDate || !endDate) {
      alert("Please select both start and end dates");
      return;
    }

    console.log("startDate", startDate);
    console.log("start date to iso", startDate.toISOString());

    // Convert dates to PST
    const startDatePST = new Date(startDate).toLocaleString("en-US", { timeZone: "America/Los_Angeles" });

    // Adjust end date to be at the end of the day in PST
    const endDatePST = new Date(endDate);
    endDatePST.setHours(23, 59, 59, 999);
    const endDatePSTString = endDatePST.toLocaleString("en-US", { timeZone: "America/Los_Angeles" });

    console.log("startDatePST", startDatePST);
    console.log("endDatePST", endDatePSTString);

    const startDatePSTFormatted = new Date(startDatePST).toISOString();
    const endDatePSTFormatted = new Date(endDatePSTString).toISOString();

    console.log("startDatePSTFormatted", startDatePSTFormatted);
    console.log("endDatePSTFormatted", endDatePSTFormatted);

    const response = await LeaderboardInstance.leaderboardBetweenDates({
      startDate: startDatePSTFormatted,
      endDate: endDatePSTFormatted,
      isUCA,
    });

    console.log("response??", response);

    if (response && response.leaderboard) {
      setLeaderboard(response.leaderboard);
    } else {
      alert("Error fetching leaderboard");
    }
  };

  return (
    <Container className="py-4">
      <h2 className="">Leaderboard</h2>
      <Form>
        <Row className="mb-3">
          <Col>
            <Form.Group>
              <Form.Label>Start Date</Form.Label>
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                dateFormat="yyyy-MM-dd"
                className="form-control"
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <Form.Label>End Date</Form.Label>
              <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                dateFormat="yyyy-MM-dd"
                className="form-control"
                showTimeSelect
                // allow minutes and seconds
                timeFormat="HH:mm"
              />
            </Form.Group>
          </Col>
        </Row>
        <Form.Group className="mb-3">
          <Form.Check type="checkbox" label="Is UCA" checked={isUCA} onChange={(e) => setIsUCA(e.target.checked)} />
        </Form.Group>
        <Button variant="primary" onClick={fetchLeaderboard}>
          Fetch Leaderboard
        </Button>
      </Form>
      <Table striped bordered hover className="mt-4">
        <thead>
          <tr>
            <th>#</th>
            <th>Username</th>
            <th>Avatar</th>
            <th>Total Seeds</th>
          </tr>
        </thead>
        <tbody>
          {leaderboard.map((entry: any, index: number) => (
            <tr key={entry.userId}>
              <td>{index + 1}</td>
              <td>{entry.user.username}</td>
              <td>
                <img
                  src={entry.user.avatarUrl}
                  alt={entry.user.username}
                  style={{ width: "50px", height: "50px", borderRadius: "50%" }}
                />
              </td>
              <td>{entry.totalSeeds}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
};
